import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "../../AuthContext"; // Import useAuth to access logout
import styles from "./Navbar.module.css";
import logo from "../Assets/logo/bodyfriendLogo.gif";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";

const Menu = ({ className, logout, role, username }) => {
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <ul className={`${className} ${styles.menuContainer}`}>
      {/* ✅ Centering "Appointments" */}
      <li
        className={`${isActive("/admin/appointment") ? styles.active : ""} ${
          styles.centerMenu
        }`}
      >
        <a href="/admin/appointment">Appointments</a>
      </li>

      {/* ✅ Display Username on the Right */}
      {username && (
        <p className={styles.username}>
          {role} - {username}
        </p>
      )}

      {/* Logout Button */}
      <li onClick={logout} className={styles.logoutButton}>
        <ExitToAppIcon />
      </li>
    </ul>
  );
};

const AdminNavbar = () => {
  const [mobileMenuState, setMobileMenuState] = useState(""); // "" | "open" | "close"
  const { user, logout } = useAuth(); // Get user info and logout function

  // Navigate with a page refresh
  const navigateWithRefresh = (path) => {
    window.location.href = path;
  };

  const handleLogout = () => {
    logout();
    navigateWithRefresh("/admin-login"); // Redirect to login page
  };

  // Toggle the state of the mobile menu
  const toggleMobileMenu = () => {
    if (mobileMenuState === "open") {
      setMobileMenuState("close");
      setTimeout(() => setMobileMenuState(""), 300); // Reset after animation
    } else {
      setMobileMenuState("open");
    }
  };

  return (
    <div className={styles.navbar}>
      {/* Hamburger Icon */}
      <div className={styles.nav_hamburger} onClick={toggleMobileMenu}>
        {mobileMenuState === "open" ? <CloseIcon /> : <MenuIcon />}
      </div>

      {/* Logo on the Left */}
      <div className={styles.nav_logo} onClick={() => navigateWithRefresh("/")}>
        <img src={logo} alt="Bodyfriend Logo" />
      </div>

      {/* Centered Menu */}
      <Menu
        className={styles.navMenu}
        logout={handleLogout}
        username={user?.name}
        role={user?.role}
      />

      {/* Mobile Menu */}
      <Menu
        className={`${styles.navMenuMobile} ${
          mobileMenuState === "open"
            ? styles.navMenuMobileOpen
            : mobileMenuState === "close"
            ? styles.navMenuMobileClose
            : ""
        }`}
        logout={handleLogout}
        username={user?.name}
        role={user?.role}
      />
    </div>
  );
};

export default AdminNavbar;
